import React, { useState } from "react";
import CFTrendsGraph from "./CFTrendsGraph";
import { Box, Grid } from "@mui/material";
import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import TableCell from "@mui/material/TableCell";
import TableContainer from "@mui/material/TableContainer";
import TableHead from "@mui/material/TableHead";
import TableRow from "@mui/material/TableRow";
import Paper from "@mui/material/Paper";

function convertToObjects(
  actualValue,
  contribution,
  factorName,
  lowerLimit,
  upperLimit
) {
  let objectsArray = [];

  for (let i = 0; i < factorName?.length; i++) {
    let obj = {
      factorName: factorName[i],
      contribution: contribution[i],
      lowerLimit: lowerLimit[i],
      upperLimit: upperLimit[i],
      actualValue: actualValue[i],
    };
    objectsArray.push(obj);
  }

  return objectsArray;
}

function CFProductsGraph({ data }) {
  const [selectedRow, setSelectedRow] = useState(null);

  const actualValue = data?.actualValue
  const contribution = data?.contribution
  const factorName = data?.factorName
  const lowerLimit = data?.lowerLimit
  const upperLimit = data?.upperLimit;
  const updatedData = convertToObjects(
    actualValue,
    contribution,
    factorName,
    lowerLimit,
    upperLimit
  );

  if (!selectedRow && updatedData?.length > 0) {
    setSelectedRow(updatedData[0]);
  }
  const handleRowClick = (row) => {
    setSelectedRow(row);
  };

  console.log("dddd",updatedData)

  return (
    <Grid
      container
      spacing={1}
      justifyContent="space-evenly"
      alignItems="center"
      display="flex"
      height={"100%"}
      //   alignItems="center"
    >
      <Grid item xs={11} sm={6} md={6} height={"100%"}>
        <TableContainer
          sx={{
            width: "100%",
            height: "100%",
            maxHeight: "100%",
            overflow: "auto",
            borderRight: "1px solid #E4E4E4",
          }}
        >
          <Table
            sx={{ width: "100%", height: "100%" }}
            aria-label="simple table"
          >
            <TableHead>
              <TableRow sx={{ borderBottom: "2px solid #B5B6B7" }}>
                <TableCell sx={{ fontSize: "12px", padding: "5px" }}>
                  Factors
                </TableCell>
                <TableCell
                  sx={{ fontSize: "12px", padding: "5px" }}
                  align="right"
                >
                  Actual
                </TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {updatedData?.map((row) => (
                <TableRow
                  key={row.factorName}
                  sx={{
                    "&:last-child td, &:last-child th": { border: 0 },
                    backgroundColor:
                      selectedRow?.factorName === row?.factorName ? "#0077B61A" : "transparent",
                    cursor: "pointer",
                  }}
                  onClick={() => handleRowClick(row)}
                >
                  <TableCell
                    sx={{ fontSize: "12px", padding: "5px" }}
                    component="th"
                    scope="row"
                  >
                    {row?.factorName}
                  </TableCell>
                  <TableCell
                    sx={{ fontSize: "12px", padding: "5px" }}
                    align="right"
                  >
                    {row?.actualValue}
                  </TableCell>
                </TableRow>
              ))}
            </TableBody>
          </Table>
        </TableContainer>
      </Grid>
      <Grid item xs={11} sm={6} md={6}>
        <Box sx={{ paddingTop: "10px" }}>
          <p style={{ padding: "5px", fontSize: "12px", fontWeight: 500 }}>
            {selectedRow?.factorName}
          </p>
          <CFTrendsGraph data={selectedRow} />
        </Box>
      </Grid>
    </Grid>
  );
}

export default CFProductsGraph;
